module.exports = __webpack_public_path__ + "static/media/Servicio Internet Satelital 1018 v11 Final.6f5b17d0.4e29ee8f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Servicio Internet Satelital 1018 v11 Final.6f5b17d0.pdf
// module id = 772
// module chunks = 0